export default {
  fr: {
    title: 'Labels décernés',
  },
  en: {
    title: 'Earned labels',
  },
  'pt-br': {
    title: 'Etiquetas conquistadas',
  },
  es: {
    title: 'Etiquetas ganadas',
  },
  de: {
    title: 'Verdiente Etiketten',
  },
} as const
